module.exports = __webpack_public_path__ + "img/switch_img1.2960f45a.png";